import { createFileRoute } from "@tanstack/react-router";

import { EditProductPage } from "@/components/Pages/Products/EditProduct.page";

export const Route = createFileRoute("/_guard/products/$productId/edit")({
  component: EditProductPage,
});
